module.exports = __webpack_public_path__ + "static/media/icon-calendar-arrow.245493d3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-calendar-arrow.svg
// module id = ./src/assets/images/icon-calendar-arrow.svg
// module chunks = 6